export default {"src":"/_next/static/media/black-ticket-icon.0baf81e9.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};